import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'treeName',
  standalone: false
})
export class NameTreeCategoryPipe implements PipeTransform {
  transform(cat: any, field = ''): any {
    if (!cat.name && !cat.label) {
      return '';
    }

    let name = cat.name ? cat.name : cat.label;
    name = name.charAt(0).toUpperCase() + name.substring(1);
    if (cat[field]) {
      name = cat[field];
    }
    if (cat.level <= 0) return name;

    const prefix = [];
    for (let i = 1; i <= cat.level; i++) {
      prefix.push('\u2012\u2012\u2012');
    }
    return `${prefix.join('')}${name}`;
  }
}
